import api from './api';
import { AUTH_TOKEN_KEY } from './config';

// Single-flight refresh shared across the interceptor, WS, and any callers.
let _refreshPromise = null;

export const refresh = async () => {
  if (_refreshPromise) return _refreshPromise;

  _refreshPromise = api
    .post('/api/auth/refresh-token', {})
    .then((response) => {
      const data = response.data;
      const newToken = data?.tokens?.accessToken;
      if (newToken) {
        localStorage.setItem(AUTH_TOKEN_KEY, newToken);
      }
      return data;
    })
    .finally(() => {
      _refreshPromise = null;
    });

  return _refreshPromise;
};
